/**
 * Token estimation utilities for browser content.
 *
 * @module truncation
 */

export const estimateTextTokens = (text: string): number =>
  text.length === 0 ? 0 : Math.max(1, Math.ceil(text.length / 4));
